import { theme } from './theme';
export const formTextFieldContainer = {
    paddingBottom: '8px',
    position: 'relative',
    width: '100%',
    justifyContent: 'center'
};
export const formErrorMessage = {
    position: 'relative',
    left: 0,
    fontSize: '14px',
    fontWeight: 400,
    color: theme.palette.common.darkRed
};
export const formPasswordVisibilityIcon = {
    position: 'absolute',
    top: '43px',
    right: '15px',
    height: '20px',
    cursor: 'pointer',
    fill: '#555555'
};
export const formPasswordHints = {
    fontSize: '13px',
    color: theme.palette.common.black,
    lineHeight: '16px'
};
export const formPasswordHintsLeft = {
    ...formPasswordHints,
    textAlign: 'left'
};
export const formPasswordHintColor = (password, passwordErrors, errorType) => {
    let color = theme.palette.common.black;
    if (password.length) {
        color =
            !passwordErrors || passwordErrors.includes(errorType)
                ? theme.palette.common.darkRed
                : theme.palette.common.darkGreen;
    }
    return { color };
};
export const formConsentData = {
    color: theme.palette.common.primaryDark,
    lineHeight: 1.6,
    fontWeight: 400,
    marginRight: 0,
    '.MuiFormControlLabel-label': {
        fontSize: '14px',
        color: theme.palette.common.primaryDark
    }
};
export const formFieldLabel = {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '21px',
    letterSpacing: 0,
    marginBottom: '8px'
};
export const formGoogleButton = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.palette.common.lightGrey6,
    borderRadius: '28px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.25)',
    color: theme.palette.common.darkGrey2,
    fontSize: '16px',
    fontWeight: 600,
    padding: '10px 20px',
    minWidth: '248px'
};
export const formLink = {
    fontWeight: 700,
    textDecoration: 'underline',
    cursor: 'pointer'
};
//# sourceMappingURL=form.js.map